export default __webpack_public_path__ + "static/media/fidel.843ce458.png";